import { render, staticRenderFns } from "./ui-app-settings.vue?vue&type=template&id=234fbf5c&scoped=true"
import script from "./ui-app-settings.vue?vue&type=script&lang=js"
export * from "./ui-app-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234fbf5c",
  null
  
)

export default component.exports